// extracted by mini-css-extract-plugin
export default {"field":"U1sVrAYB2YxFMNCXgdmQ","label":"YmVVEBKUnLKB7wxQbpgJ","student-note":"X8MS9db1Vw9t9JnATdkA","info":"GqcQwDM6jCPm_CeAKDPK"};